<template>
  <div class="index-introduce">
    <div class="container-md">
      <div class="introduce-num-box">
        <div class="introduce-num-item">
          <div class="item-num-box">
            <div class="num"><animation-num :num="40000" @animationEnd="animationEnd"></animation-num></div>
            <div class="unit big" :class="{'visible': numAnimationEnd}">+</div>
          </div>
          <div class="item-title">合作同业数量</div>
        </div>
        <div class="introduce-num-item">
          <div class="item-num-box">
            <div class="num"><animation-num :num="3100000"></animation-num></div>
            <div class="unit big" :class="{'visible': numAnimationEnd}">+</div>
          </div>
          <div class="item-title">累办签本数</div>
        </div>
        <div class="introduce-num-item">
          <div class="item-num-box">
            <div class="num"><animation-num :num="104"></animation-num></div>
          </div>
          <div class="item-title">国家覆盖</div>
        </div>
        <div class="introduce-num-item">
          <div class="item-num-box">
            <div class="num"><animation-num :num="15"></animation-num></div>
          </div>
          <div class="item-title">领区覆盖</div>
        </div>
      </div>
      <!-- <div class="introduce-video-box">
        <div class="video-desc">
          <div class="desc-title">黑科技办签</div>
          <div class="desc-text">上上签采用技术手段解决传统签证办理痛点，简化资料提交流程，办签流程实时追踪，实现办签业务全面线上化。小程序随时随地云接单，办签资料一键分享，为同业提供一键式办签体验。</div>
        </div>
        <div class="introduce-video-right">
          <div class="pc-box">
            <div class="video-wrap">
              <div @click="fullScreen" class="full-box">
                <div class="text">全屏查看</div>
              </div>
              <video id="introduce-video" src="https://o.666visa.cn/video/ssq2020-2-28.mp4" autoplay="autoplay" :controls="videoFullScreen" loop :muted="muted" height="100%" width="100%"></video>
            </div>
          </div>
          <div class="phone-box"></div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import sensorsdata from 'sa-sdk-javascript';
import AnimationNum from '../../../components/common/animation-num';

export default {
  name: 'index-introduce',
  components: {
    AnimationNum,
  },
  data() {
    return {
      videoFullScreen: this.isIE(),
      numAnimationEnd: false, // 数字动画是否结束
      muted: true,
    };
  },
  mounted() {
    this.initVideo();
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  },
  activated() {
    this.playVideo();
  },
  methods: {
    animationEnd() {
      this.numAnimationEnd = true;
    },
    initVideo() {
      window.addEventListener('resize', this.handleResize);
    },
    isIE() {
      if (!!window.ActiveXObject || 'ActiveXObject' in window) { return true; }
      return false;
    },
    handleResize() {
      const videoEl = document.querySelector('#introduce-video');
      const isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled;
      if (!isFull && videoEl) {
        this.playVideo();
        this.muted = true;
        this.videoFullScreen = false;
      }
    },
    playVideo() {
      const videoEl = document.querySelector('#introduce-video');
      try {
        videoEl && videoEl.play();
      } catch (error) {
        console.log(error);
      }
    },
    // 进入全屏
    fullScreen(e) {
      sensorsdata.quick('trackHeatMap', e.target);
      const videoEl = document.querySelector('#introduce-video');
      if (!this.isIE()) {
        this.muted = false;
      }

      const ua = window.navigator.userAgent;
      const edge = ua.indexOf('Edge/');
      if (edge > 0) {
        setTimeout(() => {
          if (videoEl.requestFullscreen) {
            videoEl.requestFullscreen();
          } else if (videoEl.mozRequestFullScreen) {
            videoEl.mozRequestFullScreen();
          } else if (videoEl.webkitRequestFullScreen) {
            videoEl.webkitRequestFullScreen();
          } else if (videoEl.msRequestFullscreen) {
            videoEl.msRequestFullscreen();
          }
        }, 0);
      } else {
        if (videoEl.requestFullscreen) {
          videoEl.requestFullscreen();
        } else if (videoEl.mozRequestFullScreen) {
          videoEl.mozRequestFullScreen();
        } else if (videoEl.webkitRequestFullScreen) {
          videoEl.webkitRequestFullScreen();
        } else if (videoEl.msRequestFullscreen) {
          videoEl.msRequestFullscreen();
        }
      }

      this.videoFullScreen = true;
    },
  },
};
</script>
<style lang="less" scoped>
.index-introduce{
  width: 100%;
  // height: 644px;
  // background: url(https://o.666visa.cn/static/ssqpeer/homepage/introduce-bg-1.png) no-repeat center;
  position: relative;
  z-index: 1;
  overflow: hidden;
  // &::after{
  //   content: '';
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   top: 0;
  //   bottom: 0;
  //   z-index: -1;
  //   background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(63,162,245,1) 100%);
  //   opacity:0.04;
  // }
  .introduce-num-box{
    display: flex;
    align-items: center;
    padding: 80px 0 80px 55px;
    line-height: 1;
    .introduce-num-item{
      flex-shrink: 0;
      text-align: center;
      &:nth-child(1){
        width: 215px;
      }
      &:nth-child(2){
        width: 280px;
        margin-left: 85px;
      }
      &:nth-child(3){
        width:120px;
        margin-left: 100px;
      }
      &:nth-child(4){
        width: 99px;
        margin-left: 120px;
      }
      .item-num-box{
        margin-bottom: 22px;
        color: #599FFF;
        font-size: 0;
        letter-spacing: -1px;
        .num{
          font-size: 64px;
          display: inline-block;
        }
        .unit{
          font-size: 16px;
          display: inline-block;
          opacity: 0;
          transition: opacity 0.3s;
          &.visible{
            opacity: 1;
          }
          &.big{
            font-size: 20px;
          }
        }
      }
      .item-title{
        color: #2F333D;
        font-size: 20px;
      }
    }
  }
  .introduce-video-box{
    display: flex;
    .video-desc{
      width: 458px;
      padding-top: 35px;
      flex-shrink: 0;
      position: relative;
      z-index: 1;
      .desc-title{
        color: #2F333D;
        font-size: 32px;
        font-weight: 600;
        line-height: 44px;
        margin-bottom: 15px;
        position: relative;
        z-index: 1;
        &::after{
          content: '';
          width:96px;
          height:8px;
          background:linear-gradient(270deg,rgba(89,159,255,0) 0%,rgba(89,159,255,1) 100%);
          position: absolute;
          bottom: 2px;
          left: 0;
          z-index: -1;
        }
      }
      .desc-text{
        color: #2F333D;
        font-size: 18px;
        line-height: 36px;
      }
    }
    .introduce-video-right{
      position: relative;
      margin-left: -100px;
      .pc-box{
        width: 788px;
        height: 388px;
        background: url(https://o.666visa.cn/static/ssqpeer/homepage/mac-pc-1.png) no-repeat;
        background-size: 100% 100%;
        .video-wrap{
          position: absolute;
          left: 191px;
          top: 13px;
          width: 432px;
          height: 252px;
          .full-box{
            cursor: pointer;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            background: transparent;
            z-index: 9;
            &:hover{
              .text{
                display: flex;
              }
            }
            .text{
              position: absolute;
              left: 50%;
              top: 50%;
              transform: translate(-50%, -50%);
              background:rgba(47,51,61,0.8);
              width:120px;
              height:48px;
              display: none;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 18px;
              border-radius: 24px;
            }
          }
        }
      }
      .phone-box{
        position: absolute;
        left: 568px;
        bottom: 0;
        width: 398px;
        height: 276px;
        background: url(https://o.666visa.cn/static/ssqpeer/homepage/phone-4.png) no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/index-introduce.vue